import _typeof from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import store from "@/store";
import util from "@/libs/util";
import api from "@/api";
import router from "@/router";
export default {
  install: function install(Vue, options) {
    // 快速打印 log
    Vue.prototype.$log = _objectSpread(_objectSpread({}, util.log), {}, {
      push: function push(data) {
        if (typeof data === "string") {
          // 如果传递来的数据是字符串
          // 赋值给 message 字段
          // 为了方便使用
          // eg: this.$log.push('foo text')
          store.dispatch("d2admin/log/push", {
            message: data
          });
        } else if (_typeof(data) === "object") {
          // 如果传递来的数据是对象
          store.dispatch("d2admin/log/push", data);
        }
      }
    });
    Vue.prototype.$operationLog = {
      editFrom: function editFrom(params) {
        var from = [];
        if (params.user_type == 0) {
          from.push("house");
        } else if (params.user_type == 1) {
          from.push("brand");
        } else if (params.user_type == 3) {
          from.push("quarter");
        }
        if (params.status == 1) {
          from.push("audit");
        } else if (params.status == 3) {
          from.push("authenticationlist");
        } else {
          from.push("list");
        }
        from.push("edit");
        return from.join("_");
      },
      push: function push(params) {
        var buttonId = "";
        if (router.currentRoute.name == "house-update" || router.currentRoute.name == "lifestyle-update" || router.currentRoute.name == "used-update" || router.currentRoute.name == "community-update" || router.currentRoute.name == "user-update") {
          if (!router.currentRoute.query.from) {
            return;
          }
          // console.log(
          //     `${router.currentRoute.query.from}_${params.code}`
          // );
          buttonId = "".concat(router.currentRoute.query.from, "_").concat(params.code);
        } else {
          // console.log(
          //     `${router.currentRoute.meta.code}_${params.code}`
          // );
          buttonId = "".concat(router.currentRoute.meta.code, "_").concat(params.code);
        }
        api.reportOperationLog(_objectSpread({
          adminId: util.cookies.get("uuid"),
          buttonId: buttonId
        }, params));
      }
    };
  }
};